export default [
    {
        path: "/attendances",
        name: "attendance",
        component: () => import("@/pages/attendance/Attendance.vue"),
        meta: {
            pageTitle: "Absensi",
            icon: "icon-[ph--clock-countdown-duotone]",
            layout: "LayoutFull",
            resource: "peserta",
            action: "read",
        },
    },
    {
        path: "/attendance-logs/:ulid?",
        name: "attendanceLogs",
        component: () => import("@/pages/attendance/AttendanceLogs.vue"),
        meta: {
            pageTitle: "Data Absensi",
            icon: "icon-[ph--clock-countdown-duotone]",
            layout: "LayoutFull",
            resource: ["peserta", "admin"],
            action: "read",
        },
    },
    {
        path: "/attendance-report",
        name: "attendanceReport",
        component: () => import("@/pages/attendance/AttendanceReport.vue"),
        meta: {
            pageTitle: "Laporan Absensi",
            icon: "icon-[tabler--report]",
            layout: "LayoutFull",
            resource: "admin",
            action: "read",
        },
    },
];
